import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'semantic-ui-react';

class GeneratedCode extends Component {
  render() {
    const {orderCode} = this.props;

    if (!orderCode) {
      return (<Grid.Column width='6' />);
    }

    return (
      <Grid.Column width='6' textAlign='right'>
        <h2>Pedido Generado: {orderCode}</h2>
      </Grid.Column>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'orderCode': state.dealerStockOrders.createdOrder,
  };
};

export default connect(mapStateToProps)(GeneratedCode);
